export enum EnumTpLeitor {
    LeitorCamera = 1,
    LeitorTeclado = 2,
    LeitorCameraTeclado = 3,
}